<form [formGroup]="loginForm" class="form-warp">
    <div class="warp-input-select">
        <input class="select" type="text" placeholder="{{ 'login.id' | translate }}" formControlName="Id"  (keydown.enter)="onIdEnter($event)"
/>
        <mat-error *ngIf="loginForm.controls.Id.errors?.['required'] && loginForm.controls.Id?.touched"
            translate>login.errors.required</mat-error>
        <mat-error *ngIf="loginForm.controls.Id.errors?.['israeliId']" translate>login.errors.invalidId</mat-error>

        <button type="button" *ngIf="!otpSent$()" class="btn"
            [ngClass]="{ disabled: loginForm.get('Id')?.invalid || sendingOtp$() }"
            [disabled]="loginForm.get('Id')?.invalid || sendingOtp$()" (click)="sendOtp()">
            <div>{{ sendingOtp$() ? ('login.sending' | translate) : ('login.sendOtp' | translate) }}</div>
        </button>
        <mat-error *ngIf="otpError$()" class="otp-error">
            {{ isTranslationKey(otpError$()!) ? (otpError$()! | translate) : otpError$()! }}
        </mat-error>

    </div>

    <div class="warp-input-select" *ngIf="otpSent$()">
        <div class="otp-validity-message" *ngIf="otpRemainingTime$() !== null && !loadingLogin$()">
            <span class="validity-text">{{ 'login.otpValidFor' | translate: {minutes: 5} }}</span>
            <span class="timer-display">({{ getFormattedRemainingTime() }})</span>
        </div>

        <input class="select" type="text" placeholder="{{ 'login.otp' | translate }}" formControlName="Otp"
            maxlength="6" />
        <mat-error *ngIf="loginForm.controls.Otp.errors?.['required'] && loginForm.controls.Otp?.touched"
            translate>login.errors.required</mat-error>
        <mat-error *ngIf="loginForm.controls.Otp.errors?.['otp']" translate>login.errors.invalidOtp</mat-error>
    </div>
</form>